import { useEffect } from "react";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { Reveal, Overline } from "../components/site/Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function Team() {
  const { t } = useLang();
  const tm = t.team;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="font-body bg-background text-nero-ink antialiased min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-16 lg:pt-[72px]">
        {/* Intro */}
        <section className="bg-white border-b border-border" data-testid="team-hero">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
            <Reveal>
              <Overline>{tm.overline}</Overline>
              <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-medium tracking-tighter text-nero-ink leading-[0.98]">
                {tm.titleLine1}
                <br />
                <span className="text-nero-green">{tm.titleLine2}</span>
              </h1>
              <p className="mt-8 max-w-2xl font-body text-base sm:text-lg leading-relaxed text-zinc-600">
                {tm.intro}
              </p>
            </Reveal>
          </div>
        </section>

        {/* Members */}
        <section className="bg-background" data-testid="team-grid">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-border">
              {tm.members.map((m, i) => (
                <Reveal key={i} delay={(i % 3) * 0.08}>
                  <div
                    className="group h-full bg-white border-b border-r border-border"
                    data-testid={`team-member-${i}`}
                  >
                    <div className="aspect-[4/5] overflow-hidden bg-zinc-100">
                      <img
                        src={m.img}
                        alt={m.name}
                        loading="lazy"
                        className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition duration-500 group-hover:scale-[1.03]"
                      />
                    </div>
                    <div className="p-7 flex items-start justify-between gap-4">
                      <div>
                        <h3 className="font-heading text-xl font-medium tracking-tight text-nero-ink">{m.name}</h3>
                        <p className="mt-1.5 font-body text-sm font-medium text-nero-green">{m.role}</p>
                      </div>
                      <span className="font-heading text-xs font-bold tabular-nums text-zinc-300">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
